import React from "react";
import { Crown, Check, TrendingUp, BarChart3, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

const PLANS = [
  {
    name: "Gratuit",
    price: "0€",
    period: "pour toujours",
    desc: "Pour découvrir Voamada",
    features: ["Upload de morceaux", "Profil artiste basique", "Likes et commentaires", "Notifications internes"],
    cta: "Commencer",
    to: "/register",
    highlight: false,
  },
  {
    name: "Premium",
    price: "4,99€",
    period: "/ mois",
    desc: "Pour les artistes ambitieux",
    features: [
      "Tout du plan Gratuit",
      "Badge Premium sur votre profil",
      "Boost de visibilité dans les tendances",
      "Statistiques d'écoute avancées",
      "Page artiste personnalisée",
      "Uploads illimités + vidéos HD",
      "Support prioritaire",
    ],
    cta: "Passer Premium",
    to: "/register",
    highlight: true,
  },
  {
    name: "Pro Label",
    price: "29€",
    period: "/ mois",
    desc: "Pour labels et collectifs",
    features: [
      "Tout du plan Premium",
      "Multi-artistes (jusqu'à 20)",
      "Analytics détaillés par artiste",
      "Billetterie de concerts intégrée",
      "Campagnes publicitaires ciblées",
      "API d'accès aux données",
    ],
    cta: "Nous contacter",
    to: "/advertisers",
    highlight: false,
  },
];

export const PremiumPage = () => {
  return (
    <div className="px-6 md:px-12 py-10 max-w-7xl mx-auto pb-32" data-testid="premium-page">
      <div className="text-center mb-14">
        <p className="inline-flex items-center gap-2 tag-pill mb-5 bg-brand-yellow/10 border-brand-yellow/30 text-brand-yellow">
          <Crown size={12} /> Voamada Premium
        </p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter mb-4 text-balance">
          Amplifiez votre voix,<br /><span className="bg-gradient-to-r from-brand-red to-brand-yellow bg-clip-text text-transparent">touchez le monde.</span>
        </h1>
        <p className="text-white/70 max-w-2xl mx-auto text-lg">
          Des outils pros pour faire décoller votre carrière musicale.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 stagger">
        {PLANS.map((p) => (
          <div key={p.name} className={`rounded-2xl p-8 border ${p.highlight ? "border-brand-red bg-gradient-to-b from-brand-red/10 to-transparent" : "border-white/10 bg-white/[0.02]"}`} data-testid={`plan-${p.name.toLowerCase().replace(/\s/g, "-")}`}>
            {p.highlight && (
              <p className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest font-bold text-brand-red mb-3">
                <Sparkles size={10} /> Le plus populaire
              </p>
            )}
            <h3 className="font-display text-2xl font-black mb-1">{p.name}</h3>
            <p className="text-white/60 text-sm mb-4">{p.desc}</p>
            <div className="mb-6">
              <span className="font-display text-5xl font-black">{p.price}</span>
              <span className="text-white/60 text-sm ml-2">{p.period}</span>
            </div>
            <ul className="space-y-3 mb-8">
              {p.features.map((f) => (
                <li key={f} className="flex items-start gap-2 text-sm">
                  <Check size={16} className="text-brand-red mt-0.5 shrink-0" />
                  <span className="text-white/80">{f}</span>
                </li>
              ))}
            </ul>
            <Link to={p.to} className={p.highlight ? "btn-primary w-full text-center block" : "btn-ghost w-full text-center block"} data-testid={`cta-${p.name.toLowerCase().replace(/\s/g, "-")}`}>
              {p.cta}
            </Link>
          </div>
        ))}
      </div>

      {/* Benefits */}
      <div className="grid md:grid-cols-3 gap-6 mt-20 stagger">
        <Benefit icon={<TrendingUp size={22} />} title="Visibilité boostée" desc="Votre musique mise en avant dans les tendances et recommandations." />
        <Benefit icon={<BarChart3 size={22} />} title="Stats en temps réel" desc="Comprenez votre audience : pays, âge, moments d'écoute." />
        <Benefit icon={<Crown size={22} />} title="Badge Premium" desc="Un signe de crédibilité qui rassure les labels et organisateurs." />
      </div>
    </div>
  );
};

const Benefit = ({ icon, title, desc }) => (
  <div className="border border-white/10 bg-white/[0.02] rounded-2xl p-6">
    <div className="w-11 h-11 rounded-full bg-brand-red/15 text-brand-red flex items-center justify-center mb-4">{icon}</div>
    <h4 className="font-display text-lg font-bold mb-2">{title}</h4>
    <p className="text-white/60 text-sm">{desc}</p>
  </div>
);

export default PremiumPage;
